import PropTypes from 'prop-types';
import styles from './single-input-with-ok-and-cancel.module.less';
import FormError from '../form-error/FormError';
import RoundedButtonPrimary from '../button/rounded-button-primary/RoundedButtonPrimary';
import RoundedButtonSecondary from '../button/rounded-button-secondary/RoundedButtonSecondary';

const GoIconDefault = () => <i className="fa-solid fa-check"></i>;

const CancelIconDefault = () => <i className="fa-solid fa-xmark"></i>;

const SingleInputWithOkAndCancel = ({
    placeholder = '',
    innerRef = () => {},
    onKeyDown = () => {},
    onBlur = () => {},
    onChange = () => {},
    onGo,
    onCancel,
    GoIcon = GoIconDefault,
    CancelIcon = CancelIconDefault,
    error,
    value,
}) => {
    return (
        <div className={styles.container}>
            <input
                type="text"
                placeholder={placeholder}
                className={styles.urlInput}
                onKeyDown={onKeyDown}
                ref={innerRef}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
            />
            <RoundedButtonPrimary className={styles.button} onClick={onGo}>
                <GoIcon />
            </RoundedButtonPrimary>
            <RoundedButtonSecondary type="button" className={styles.button} onClick={onCancel}>
                <CancelIcon />
            </RoundedButtonSecondary>
            {error && <FormError className={styles.error} error={error} />}
        </div>
    );
};

SingleInputWithOkAndCancel.propTypes = {
    onGo: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default SingleInputWithOkAndCancel;
